/**
 * RESPONSIBILITY: match a band's template to the component that draws it.
 *
 * A lookup and not a `switch`: a new template is a key here and a file beside it. A band
 * saved with NO template is the original one - see band-themes.ts - which is what makes
 * every ministry page that existed before templates draw exactly as it did. A template
 * this build has never heard of draws nothing rather than throwing: that is a deployment
 * mid-flight, not a reason to show a visitor a blank page.
 */
import { BAND_THEME as T, DEFAULT_BAND_THEME, type MinistryBand } from '@app/sections';
import {
  text, image, imageLeft, imageRight, imageTop, textTop, faq, video, gallery, type BandDef,
} from '../../commons/bands';
import { alternating } from './BandAlternating';

const BANDS: Record<string, BandDef> = {
  [T.Alternating]: alternating,
  [T.Text]: text,
  [T.Image]: image,
  [T.ImageLeft]: imageLeft,
  [T.ImageRight]: imageRight,
  [T.ImageTop]: imageTop,
  [T.TextTop]: textTop,
  [T.Faq]: faq,
  [T.Video]: video,
  [T.Gallery]: gallery,
};

export const bandOf = (b: MinistryBand): BandDef | undefined => BANDS[b.theme || DEFAULT_BAND_THEME];
